import React, { useEffect, useState, useRef } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactPaginate from "react-paginate";

let Rewardcashbackreq = () => {
  let [data, setData] = useState();

  let navigate = useNavigate();

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  let [all, setAll] = useState(0);
  let [used, setUsed] = useState(0);
  let [notused, setnotUsed] = useState(0);
  let [expired, setExpired] = useState(0);
  let [notscratchyet, setnotscratchyet] = useState(0);
  let [indexs, setIndex] = useState(0);
  let [selas, setSelas] = useState();
  let [search, setSearch] = useState();

  useEffect(() => {
    Start();
    // Payment();
    RewardDeath();
  }, []);

  let Searchval = async () => {

    try {
      let token = await localStorage.getItem("token");

      let pp = { token, page: 1, limit: 10 };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/cashbackrequestsearch",
        data: {search : search},
      })
        .then((dat) => {
          console.log(
            dat.data,
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );

          if (dat.data.status === true) {
            setData(dat.data.data);
            setAll(dat.data.count);
            let expireds = 0;
            let alls = 0;
            let notuseds = 0;
            let useds = 0;
            let notscratchs = 0;

            // dat?.data?.data.map((dd, key) => {

            //   alls = alls + Number(dd?.amount);

            // });

            // setAll(alls);
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  }






  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let RewardDeath = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, page: 1, limit: 10 };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/cashbackrequest",
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data,
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );

          if (dat.data.status === true) {
            setData(dat.data.data);
            setAll(dat.data.count);
            let expireds = 0;
            let alls = 0;
            let notuseds = 0;
            let useds = 0;
            let notscratchs = 0;

            // dat?.data?.data.map((dd, key) => {

            //   alls = alls + Number(dd?.amount);

            // });

            // setAll(alls);
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };


  function formatDateShort(date) {
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
    });
  }


  function addWorkingDays(date, daysToAdd) {
    let resultDate = new Date(date); // Copy the input date to avoid modifying the original

    while (daysToAdd > 0) {
      resultDate.setDate(resultDate.getDate() + 1); // Increment the date by one day

      // Check if the new date is a weekday (not Saturday or Sunday)
      const dayOfWeek = resultDate.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        // 0 = Sunday, 6 = Saturday
        daysToAdd--; // Only decrement if it's a weekday
      }
    }

    return formatDateShort(resultDate); // Format in "09 Oct" format
  }


  const handlePageClick = async (event) => {
    console.log(event.selected);
    setIndex(event.selected);

    try {
      let token = await localStorage.getItem("token");

      let pp = { token, page: event.selected + 1, limit: 10 };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/cashbackrequest",
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data,
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );

          if (dat.data.status === true) {
            setData(dat.data.data);
            setAll(dat.data.count);
            let expireds = 0;
            let alls = 0;
            let notuseds = 0;
            let useds = 0;
            let notscratchs = 0;

            // dat?.data?.data.map((dd, key) => {

            //   alls = alls + Number(dd?.amount);

            // });

            // setAll(alls);
          } else {
          }
        })
        .catch((ee) => { });
    } catch (err) { }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      sub: "",
      exptime: "",
      offertype: "percentage", // default to percentage
      offer: "",
      usertype: "", // default to all
      categorybbps: "",
      rentavaliable: false,
      active: false,
      min: "",
      max: "",
      presentage_avaliable: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      min: Yup.string().required("Min is required"),
      max: Yup.string().required("Max is required"),
      sub: Yup.string().required("Sub is required"),
      exptime: Yup.string().required("Expiration time is required"),
      offertype: Yup.string().required("Offer type is required"),
      offer: Yup.number().required("Offer is required"),
      usertype: Yup.string().required("User type is required"),
      categorybbps: Yup.string().required("Category BBPS is required"),
      presentage_avaliable: Yup.string().required(
        "presentage_avaliable BBPS is required"
      ),
    }),
    onSubmit: (values) => {
      // Handle form submission
      console.log("Form Data:", values);
    },
  });

  const inputStyle = {
    margin: "5px 0",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "100%",
  };

  const labelStyle = {
    display: "block",
    marginBottom: "5px",
    fontWeight: "700",
  };

  const errorStyle = {
    color: "red",
    fontSize: "12px",
    marginTop: "5px",
  };

  const containerStyle = {
    display: "flex",
    gap: "20px",
    padding: "20px",
    textAlign: "left",
  };

  const sectionStyle = {
    flex: 1,
  };

  const formSectionStyle = {
    border: "1px solid #ddd",
    borderRadius: "4px",
    padding: "20px",
    marginBottom: "20px",
  };

  function calculateDates(daysToAdd) {
    const currentDate = new Date(daysToAdd);
    currentDate.setDate(currentDate.getDate());

    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = currentDate.getFullYear();

    return `${day}/${month}/${year}`;
  }

  function calculateDate(daysToAdd, createdat) {
    const currentDate = new Date();
    const targetDate = new Date(createdat);
    targetDate.setDate(targetDate.getDate() + daysToAdd);

    // Compare the targetDate with the currentDate
    if (targetDate < currentDate) {
      return 1; // Target date is in the past
    } else {
      return 0; // Target date is today or in the future
    }
  }

  function calculateDatetarget(daysToAdd, createdat) {
    const currentDate = new Date();
    const targetDate = new Date(createdat);
    targetDate.setDate(targetDate.getDate() + daysToAdd);

    const day = String(targetDate.getDate()).padStart(2, "0");
    const month = String(targetDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = targetDate.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const tabRef = useRef(null);

  // Function to handle tab click
  const handleTabClick = (event) => {
    if (event.target.id === "profile-tab") {
    } else if (event.target.id === "contact-tab") {
    } else if (event.target.id === "used-tab") {
    } else {
    }
  };

  useEffect(() => {
    const tabElement = tabRef.current;

    const handleTabChange = (event) => {
      console.log(event.target.id);
    };

    // Add event listener for tab shown.bs.tab
    tabElement.addEventListener("shown.bs.tab", handleTabChange);

    return () => {
      // Cleanup the event listener when the component unmounts
      tabElement.removeEventListener("shown.bs.tab", handleTabChange);
    };
  }, []);


  let badboy = async (ds) => {
    console.log(ds, 'hhhh', selas)

    if (selas === undefined) {

      alert("Change ststus");
      return
    }
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, dsg: ds._id, selas };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/cashbackchange",
        data: pp,
      })
        .then((dat) => {

          RewardDeath()
        })
        .catch((ee) => { });
    } catch (err) { }

  }

  return (
    <div>
      <div className="row">
        <Header />
        <div
          className="col-10"
          style={{
            overflowY: "scroll",
            height: "100vh",
            scrollbarWidth: "none",
          }}
        >
          <div className="d-flex justify-content-between">
            <h1 style={{ textAlign: "center", fontSize: 23 }} className="mt-4">
              Cashback details
            </h1>
            <div style={{ padding: 10 }}></div>
          </div>
          <div class="container mt-5 w-100">
            <div className="d-flex justify-content-between">
              <ul
                class="nav nav-tabs w-100 d-flex"
                id="myTab"
                role="tablist"
                style={{ justifyContent: "space-between" }}
                ref={tabRef}
              >
                <li class="nav-item" role="presentation" style={{}}>
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    pageCount={all / 10}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName="pagination justify-content-center"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    forcePage={indexs}
                  />
                </li>
              </ul>
              <div className="d-flex justify-content-end">
                <input type="text" className="form-control" placeholder="Search" style={{ width : 250 , marginRight : 10 }} onChange={(e) => {
                  setSearch(e.target.value);
                }} />
                <button
                  className="btn btn-primary"
                  onClick={() => {
                     Searchval()
                  }}
                >
                  Submit
                </button>
              </div>
            </div>


            <div class="tab-content mt-5" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="home"
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <div className="row">
                  <div className="col-2">{/* <p>All : {all}</p> */}</div>
                </div>
                <table class="table table-striped table-hover table-bordered table-sm">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">User</th>
                      <th scope="col">Merchant</th>
                      <th scope="col">Time</th>
                      <th scope="col">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((dd, key) => {
                      let fffs = JSON.parse(dd.bank.all_data);

                      return (
                        <>
                          <tr
                            
                          >
                            <th scope="row">{key + 1}</th>
                            <td onClick={() => {
                              navigate("/useralldetail", { state: dd.user });
                            }}  style={dd?.user?.fraud === true ? {backgroundColor : 'orange'} : {}}  >
                              <div>
                                <p>Name : {dd?.user?.name}</p>
                                <p>phoneno : {dd?.user?.phoneno}</p>
                              </div>
                            </td>
                            <td  >
                              <div>
                                <p>Merchant Name : {fffs?.nameAtBank}</p>
                                <p>Bank Name : {fffs?.bankName}</p>
                                <p style={{ fontWeight: "700" }}>
                                  Account No : {dd?.bank?.account_No}
                                </p>
                                <p style={{ fontWeight: "700" }}>
                                  Ifsc : {dd?.bank?.ifsc}
                                </p>
                              </div>
                            </td>
                            <td>
                              <p>
                                Initate date : {calculateDates(dd?.createdAt)}
                              </p>
                              <p>Settlement Date : {addWorkingDays(dd?.createdAt, 2)}</p>
                              <p>_id : {dd._id}</p>
                            </td>
                            <td>
                              <p style={{ fontWeight: '700' }}>Amount : {dd?.amount}</p>
                              <p>Payment Status : <span style={{
                                fontWeight: '700',
                                color: dd?.payment_status_msg === 'Processing' ? 'orange' : "#000"
                              }}>{dd?.payment_status_msg}</span></p>

                              <div className="row" >
                                <div className="col-6" >


                                  <select
                                    onChange={(e) => {
                                      setSelas(e.target.value);
                                    }}
                                    name="payment_status"
                                    id="payment_status"
                                    style={{
                                      padding: "5px",
                                      borderRadius: "4px",
                                      border: "1px solid #ccc",
                                    }}
                                  >
                                    <option
                                      value="Failed"
                                      selected={dd?.payment_status_msg === "Failed"}
                                    >
                                      Failed
                                    </option>
                                    <option
                                      value="Success"
                                      selected={
                                        dd?.payment_status_msg === "Success"
                                      }
                                    >
                                      Success
                                    </option>
                                    <option
                                      value="Processing"
                                      selected={
                                        dd?.payment_status_msg === "Processing"
                                      }
                                    >
                                      Processing
                                    </option>
                                    <option
                                      value="Refund"
                                      selected={dd?.payment_status_msg === "Refund"}
                                    >
                                      Refund
                                    </option>
                                  </select>



                                </div>
                                <div className="col-6" >
                                  <button
                                    onClick={() => {
                                      badboy(dd)
                                    }}
                                  >Submit</button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rewardcashbackreq;
